import { render, staticRenderFns } from "./contentCourseExamMove.vue?vue&type=template&id=18361e72&"
import script from "./contentCourseExamMove.vue?vue&type=script&lang=js&"
export * from "./contentCourseExamMove.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports